export default __webpack_public_path__ + "static/media/858_5.81f0810f.jpg";